import { render, staticRenderFns } from "./PoolSandTank.vue?vue&type=template&id=6a4ded00&scoped=true&"
import script from "./PoolSandTank.vue?vue&type=script&lang=js&"
export * from "./PoolSandTank.vue?vue&type=script&lang=js&"
import style0 from "./PoolSandTank.vue?vue&type=style&index=0&id=6a4ded00&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4ded00",
  null
  
)

export default component.exports